import React, { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import { ModalComponent } from "components/ModalComponent";
import { submitKey } from "config/constants";

type Props = {
  open: boolean;
  title: string;
  children: ReactNode;
  actions: ReactNode;
  handleClose?: () => void;
  width?: string;
};

export const LegalDocumentModal = ({
  open,
  title,
  children,
  actions,
  handleClose,
  width = "720px",
}: Props) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === submitKey) {
      event.stopPropagation();
    }
  };

  return (
    <ModalComponent
      open={open}
      handleClose={handleClose}
      boxStyles={{
        width,
        maxWidth: "calc(100vw - 32px)",
        height: "670px",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "flex-start",
        borderRadius: "6px",
        overflow: "hidden",
      }}
    >
      <Box
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-modal-title"
        onKeyDown={handleKeyDown}
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }}
      >
        <Box
          sx={{
            width: "100%",
            flexShrink: 0,
            p: { xs: "15px 20px", sm: "15px 40px" },
            bgcolor: "secondary.main",
          }}
        >
          <Typography
            component="h2"
            id="modal-modal-title"
            sx={{ fontSize: "14px", fontWeight: 600, color: "common.white" }}
          >
            {title}
          </Typography>
        </Box>
        <Box
          sx={{
            width: "100%",
            flex: 1,
            minHeight: 0,
            p: { xs: "20px", sm: "30px 20px 30px 40px" },
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            overflow: "hidden",
          }}
        >
          <Box
            id="modal-modal-description"
            tabIndex={0}
            aria-label="Legal document content"
            sx={{
              flex: 1,
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
              gap: "15px",
              overflow: "auto",
              "&::-webkit-scrollbar": {
                width: "14px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#D9D9D9",
                borderRadius: "6px",
              },
              pr: { xs: "8px", sm: "20px" },
              scrollbarGutter: "stable",
              "& > .MuiAccordion-root": { flexShrink: 0 },
            }}
          >
            {children}
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: "16px",
              flexShrink: 0,
              pt: "24px",
              justifyContent: "center",
              pr: { xs: 0, sm: "20px" },
            }}
          >
            {actions}
          </Box>
        </Box>
      </Box>
    </ModalComponent>
  );
};
